(() => {
  const getModal = () => document.querySelector('[data-birdex-size-guide-modal]');

  const setSizeGuideHidden = (hidden) => {
    const modal = getModal();
    if (!modal) return;

    modal.hidden = hidden;
    document.documentElement.classList.toggle('birdex-size-guide-open', !hidden);

    if (!hidden) {
      modal.querySelector('.birdex-size-guide-modal__dialog')?.focus();
    }
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-birdex-size-guide-open]');
    if (openButton) {
      event.preventDefault();
      setSizeGuideHidden(false);
      return;
    }

    if (event.target.closest('[data-birdex-size-guide-close]')) {
      event.preventDefault();
      setSizeGuideHidden(true);
      return;
    }

    const tabButton = event.target.closest('[data-birdex-size-tab]');
    if (tabButton) {
      const modal = getModal();
      const target = tabButton.dataset.birdexSizeTab;
      if (!modal || !target) return;

      modal.querySelectorAll('[data-birdex-size-tab]').forEach((tab) => {
        const active = tab === tabButton;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      modal.querySelectorAll('[data-birdex-size-panel]').forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.birdexSizePanel === target);
      });
      return;
    }

    const unitButton = event.target.closest('[data-birdex-unit]');
    if (unitButton) {
      const modal = getModal();
      const target = unitButton.dataset.birdexUnit;
      if (!modal || !target) return;

      modal.querySelectorAll('[data-birdex-unit]').forEach((tab) => {
        tab.classList.toggle('is-active', tab === unitButton);
      });

      modal.querySelectorAll('[data-birdex-size-chart]').forEach((chart) => {
        chart.classList.toggle('is-active', chart.dataset.birdexSizeChart === target);
      });
    }
  });

  document.addEventListener('keydown', (event) => {
    const modal = getModal();
    if (event.key === 'Escape' && modal && !modal.hidden) {
      setSizeGuideHidden(true);
    }
  });
})();
